import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "text", "textProps", "type", "icon", "iconSize", "withAlert", "alertText", "alertTextWidth", "alertTextStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames/bind';
import { bool, node, number, object, oneOf, string } from 'prop-types';
import { Critical, S7ProfiCircle, WarningFilled, WarningLinear } from "../icons";
import { TextBase } from "../internal/TextBase";
import noop from "../utils/noop";
import Tooltip from '../Tooltip';
import { defaultAlertTextStyle, iconSizes, types } from './constants';
import styles from './NotificationBlock.css';
var cx = classNames.bind(styles);
var iconByType = {
  warning: /*#__PURE__*/React.createElement(WarningFilled, {
    size: "md"
  }),
  error: /*#__PURE__*/React.createElement(Critical, {
    size: "md"
  }),
  info: /*#__PURE__*/React.createElement(S7ProfiCircle, {
    height: "24",
    width: "24"
  })
};
var smallIconByType = {
  warning: /*#__PURE__*/React.createElement(WarningFilled, null),
  info: /*#__PURE__*/React.createElement(S7ProfiCircle, {
    height: "16",
    width: "16"
  }),
  error: /*#__PURE__*/React.createElement(Critical, null)
};

var NotificationBlock = function NotificationBlock(_ref) {
  var _cx;

  var children = _ref.children,
      text = _ref.text,
      textProps = _ref.textProps,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? types[0] : _ref$type,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      _ref$withAlert = _ref.withAlert,
      withAlert = _ref$withAlert === void 0 ? false : _ref$withAlert,
      alertText = _ref.alertText,
      _ref$alertTextWidth = _ref.alertTextWidth,
      alertTextWidth = _ref$alertTextWidth === void 0 ? 200 : _ref$alertTextWidth,
      _ref$alertTextStyle = _ref.alertTextStyle,
      alertTextStyle = _ref$alertTextStyle === void 0 ? defaultAlertTextStyle : _ref$alertTextStyle,
      rest = _objectWithoutProperties(_ref, _excluded);

  var icons = iconSize === 'small' ? smallIconByType : iconByType;
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cx('Notification', (_cx = {}, _defineProperty(_cx, "Notification_type_".concat(type), type), _defineProperty(_cx, "slave", !children), _cx))
  }), children, /*#__PURE__*/React.createElement("div", {
    className: cx('info')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Icon')
  }, icon !== null && icon !== void 0 ? icon : icons[type]), /*#__PURE__*/React.createElement("div", {
    className: cx('Text')
  }, /*#__PURE__*/React.createElement(TextBase, _extends({
    size: "m",
    color: "N900"
  }, textProps), text)), withAlert && /*#__PURE__*/React.createElement("div", {
    className: cx('alertIcon')
  }, alertText ? /*#__PURE__*/React.createElement(Tooltip, {
    id: "notification-block-tooltip",
    popoverProps: {
      style: _objectSpread({
        maxWidth: alertTextWidth
      }, alertTextStyle)
    },
    direction: "top",
    offset: 10,
    content: alertText,
    opened: true,
    onClick: noop
  }, /*#__PURE__*/React.createElement(WarningLinear, null)) : /*#__PURE__*/React.createElement(WarningLinear, null))));
};

NotificationBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Содержимое к которому будет относиться блок нотификации
   */
  children: node.isRequired,

  /**
   * Текст нотификации, обернут в TextBase
   */
  text: node.isRequired,

  /**
   * Дополнительные параметры для TextBase
   */
  textProps: object,

  /**
   * Тип отображения
   */
  type: oneOf(types),

  /**
   * Иконка рядом с текстом
   */
  icon: node,

  /**
   * Размер иконки
   */
  iconSize: oneOf(iconSizes),

  /**
   * Включить отображение подсказки справа от текста
   */
  // eslint-disable-next-line react/boolean-prop-naming
  withAlert: bool,

  /**
   * Текст подсказки
   */
  alertText: string,

  /**
   * Задать ширину для подсказки
   */
  alertTextWidth: number,

  /**
   * Дополнительные стили для текста подсказки
   */
  alertTextStyle: object
} : {};
NotificationBlock.defaultProps = {
  type: 'warning',
  alertTextWidth: 200,
  alertTextStyle: {
    textAlign: 'left'
  }
};
export default NotificationBlock;